<template>
  <v-layout>
<v-flex class="elevation-9" v-for="item in SingleGroups" :key="`grp` + item.id" >
    <v-form ref="form">
      <groupHeader :groupTitle="item.title" :id="`grp` + item.id"></groupHeader>
      <v-card-text flat class="py-1">
        <v-layout  column align-center v-for="(params,paramIndex) in item.params" :key="`g` + item.id + `p_` + params.id" :title="params.description">            
            <itemParam v-bind:content="getParameters(params)" v-model="params.value" :grpId="item.id"
              v-on:input="specFuncHandler(params, $event, 0, 0, paramIndex) " 
              v-on:change="specFuncHandler(params, $event, 0, 0, paramIndex) " 
            ></itemParam>
        </v-layout>
      </v-card-text>
      <groupFooterButton 
      v-if="item.submit" 
      :buttonText="item.submit.title" 
      :onClick="toClick" :params="item" 
      :inputWidth="item.submit.inputWidth" 
      :inputHeight="item.submit.inputHeight" 
      :bold="item.submit.bold">
      </groupFooterButton>      
    </v-form>
</v-flex>
<v-flex class="elevation-9" v-for="(item, rootGrpIndex) in TableGroups" :key="`ggrp` + item.id" my-0>  
  <v-form ref="form">
  <v-data-iterator
    :items="item.groups"
    content-tag="v-layout"
    :rows-per-page-items="rowsPerPageItems"
    :pagination.sync="pagination"
    hide-default-footer>
         <groupHeader slot="header" v-if="(item.newLine)" :groupTitle="item.title"></groupHeader>
          <v-flex
            slot="item"
            slot-scope="props"
            class ="pt-0"
            flat
          >
            <v-card flat >
              <groupHeader v-if="!(item.newLine)" :groupTitle="props.item.title" :id="`grp` + props.item.id"></groupHeader>
              <v-card-title v-else class="grey--text"><h3>{{ props.item.title }}</h3></v-card-title>
              <v-divider></v-divider>
              <v-list dense class="pb-0"> 
                <v-card class="px-3">
                <itemParam  
                  v-for="(params,paramIndex) in props.item.params" 
                  :key="`g` + item.id + `p_` + params.id" 
                  v-bind:content="getParameters(params)" 
                  v-model="params.value" :grpId="item.id"
                  v-on:input="specFuncHandler(params, $event, rootGrpIndex, props.item, paramIndex) " 
                  v-on:change="specFuncHandler(params, $event, rootGrpIndex, props.item, paramIndex) " 
                ></itemParam>
                </v-card>
              </v-list>
            </v-card>
          </v-flex>
    <v-card class="text-xs-center" slot="footer">
      <v-flex v-if="rowpages>1">
        <v-pagination 
          v-model="pagination.page"
          :length="rowpages"
          prev-icon="chevron_left"
          next-icon="chevron_right"
        ></v-pagination>
      </v-flex>
      <v-layout         row
        justify-space-between>
        <v-flex xs3>  </v-flex>
       <v-flex xs3>           
        <groupFooterButton 
        v-if="item.submit" 
        :buttonText="item.submit.title" 
        :onClick="groupsClick" :params="item" 
        :inputWidth="item.submit.inputWidth" 
        :inputHeight="item.submit.inputHeight" 
        :bold="item.submit.bold">
        </groupFooterButton>    
        </v-flex>
      <v-flex xs3 >
        <v-checkbox  v-if="item.selectAll"
          @change="toSelectAll(item, $event)" 
          v-model="selAllChecked" 
          color="primary"
          v-bind:id="`selAll` + item.groups[0].id"
          :label="item.selectAll.title">
        </v-checkbox>
      </v-flex>
      
      </v-layout>
    </v-card>
  </v-data-iterator>
   </v-form>
</v-flex>
  </v-layout>
</template>

<script>

import groupHeader from './groupHeader'
import itemParam from './itemParam'
import groupFooterButton from './groupFooterButton'


export default {
  name: 'pages',
  components: {
    itemParam,
    groupHeader,
    groupFooterButton
  },
  props: {
/*    pageID: {
      required: true,
      type: Number
    }
    jsonURL: {
      required: true,
      type: String
    } */
  },
  data () {
    return {
      DPI: 1,
      selected: [],
      selAllChecked: false,
      tableHeaders:'',
      rowsPerPageItems: [1,2,4],
      pagination: {
        rowsPerPage: 1
      },
    }
  },
  beforeDestroy () {
    if (typeof window !== 'undefined') {
      window.removeEventListener('resize', this.onResize, { passive: true })
    }
  },
  created () {
    this.onResize()

    window.addEventListener('resize', this.onResize, { passive: true })
  },
  computed: {
    TableGroups: function () {
      var newArr = []
      this.$store.getters.getActiveGroups.forEach(function(item) {
        if (item.groups) 
          newArr.push(item)
      })
      return newArr
    },
      SingleGroups: function () {
      var newArr = []
      this.$store.getters.getActiveGroups.forEach(function(item) {
        if (!item.groups) 
          newArr.push(item)
      })
      return newArr
    },
    allGroups: function () {
      var newArr = {}
      this.$store.getters.getActiveGroups.forEach(function(item) {
        if (item.groups) {
          item.groups.forEach (function (item) {
            newArr[item.id] = item
          }, this)
        } else newArr[item.id] = item
      })
      return newArr
    },
    groups: function () {
      var newArr = []
      this.$store.getters.getActiveGroups.forEach(function(item) {
        if (item.newLine) {
          newArr.push({'Line': true, 'padding': (item.padding ? item.padding : 5)})
        }
        newArr.push(item)
      })
      return newArr
    },
    rowpages () {
        if (this.pagination.rowsPerPage == null ||
          this.pagination.totalItems == null
        ) return 0

        return Math.ceil(this.pagination.totalItems / this.pagination.rowsPerPage)
      }
  },
  methods: {
    onResize () {
      this.DPI = window.devicePixelRatio
      // this.rowsPerPage = Math.round(window.innerWidth / (490*window.devicePixelRatio))
      // this.pagination.rowsPerPage = Math.round(window.innerWidth / (490*window.devicePixelRatio))
      
    },
    specFuncHandler: function (target, ev, rootIndex, grp, index) {
      
      if (target.specFunc === 'chBandwidth') {
        target.specFuncData1.forEach(function (item, itemIndex) {
          this.groups[rootIndex].groups[item].params[index].value = ev
          this.groups[rootIndex].groups[item].params[target.specFuncData2].value = parseInt(this.groups[rootIndex].groups[item - 1].params[target.specFuncData2].value) + (ev * (itemIndex + 1))
          this.groups[rootIndex].groups[item].params[target.specFuncData3].value = this.groups[rootIndex].groups[item].params[target.specFuncData2].value
        }, this)
      }
      if (target.specFunc === 'chAtten') {
        target.specFuncData1.forEach(function (item, itemIndex) {
          this.groups[rootIndex].groups[item].params[index].value = ev
        }, this)
      }
      if (target.specFunc === 'chFrequency') {
        // if (ev.target) {
          target.specFuncData1.forEach(function (item, itemIndex) {
            this.groups[rootIndex].groups[item].params[index].value = parseInt(ev)// + parseInt(this.groups[rootIndex].groups[item].params[target.specFuncData2].value) * (itemIndex + 1)
            this.groups[rootIndex].groups[item].params[target.specFuncData3].value = this.groups[rootIndex].groups[item].params[index].value
          }, this)
          grp.params[target.specFuncData3].value = grp.params[index].value
        // }
      }
      if (target.specFunc === 'chFrequency2') {
        var foundOption = grp.params[target.specFuncData3].options.find(x => x.id === parseInt(ev))
        if(foundOption)
          grp.params[target.specFuncData3].value =foundOption.value
      }
      if (target.specFunc === 'chRFChannel') {
        // alert(this.groups[rootIndex].groups[grpIndex].params[index].value)
        grp.params[target.specFuncData3].value = parseInt(ev)
        target.specFuncData1.forEach(function (item, itemIndex) {
          this.groups[rootIndex].groups[item].params[target.specFuncData3].value = parseInt(ev) + parseInt(this.groups[rootIndex].groups[item].params[target.specFuncData2].value) * (itemIndex + 1)
          this.groups[rootIndex].groups[item].params[index].value = this.groups[rootIndex].groups[item].params[target.specFuncData3].value
        }, this)
      }
      if (target.specFunc === 'chRFChannel2') {
        grp.params[target.specFuncData3].value = parseInt(target.options.find(x => x.value === ev).id )
        if(target.specFuncData2)
        {
          var chBandwidth = target.options.find(x => x.value === (ev +1)).id - target.options.find(x => x.value === ev).id
          if(chBandwidth > 8000)
            chBandwidth = target.options.find(x => x.value === (ev)).id - target.options.find(x => x.value === (ev-1)).id
          grp.params[target.specFuncData2].value = chBandwidth/1000
        }
      }
      if(target.specFunc === 'resolutionSel'){        
        this.groups[rootIndex].params[target.specFuncData2].value = target.options.find(x => x.value === ev).value2 
      }
      if(target.specFunc === 'disableParams'){     
        if(target.value)
          target.specFuncData1.forEach(function (item, itemIndex){
              this.groups[rootIndex].params[item].disabled = false 
          },this)
        else
          target.specFuncData1.forEach(function (item, itemIndex){
              this.groups[rootIndex].params[item].disabled = true 
          },this)
        
      }
    },
    toSelectAll: function (item, value) {
      var Target = item.selectAll.target
      for (var I in item.groups[0].params) {
        if (item.groups[0].params[I].id === Target) {
          item.groups.forEach(function (grp) {
            grp.params[I].value = value ? 1 : 0
          })
          break
        }
      }
      this.selAllChecked = value
      // alert(this.selAllChecked)
    },
    Paspausk: function (item) {
      var obj = []  // Grupiu sarashas cia bus
      item.groups.forEach(function (grp) {
        var G = {group: grp.id, params: {}}
        grp.params.forEach(function (param) {
          G.params[param.id] = typeof (param.value) === 'boolean' ? (param.value ? 1 : 0) : param.value
        })
        obj.push(G)
      })
      // alert(JSON.stringify(obj))
      this.$http.post('ajax.cgi', 'cmd=setJSONParams&content=' + JSON.stringify(obj).replace(/&/g, '%26')).then(
        function (response) {
          // if (response.data.status < 0) this.$store.commit('showMessage', {text: response.data.error, type: 'error'})
          // else this.$store.commit('showMessage', {text: response.data.message, type: 'ok'})
          this.$store.commit('showMessage', {text: response.data.message, type: (response.data.status < 0) ? 'error' : 'ok', timeOut: response.data.timeOut})
        },
        function (error) {
          this.$store.commit('showMessage', {text: error.statusText, type: 'error'})
        }
      )
    },
    getParameters: function (obj) {
      var Result = {}




      if (obj.inputWidth) Result.inputWidth = obj.inputWidth
      else Result.inputWidth = 100
      if (obj.textAlign) Result.textAlign = obj.textAlign
      if (obj.paddingLeft) Result.paddingLeft = obj.paddingLeft + 'px'

      Result.value = obj.value
      Result.label = obj.title;

      if (obj.type === 0) {       // Digital
        Result.type = 'Number'
        Result.name = obj.id
        Result.min = obj.min
        Result.max = obj.max
        Result.step = obj.step ? obj.step : 1
        Result.inputWidth -= 6
        if (obj.disabled) Result.disabled = obj.disabled
        if (obj.dimension) Result.dim = obj.dimension
      }
      if (obj.type === 1) {    // float
        // TODO - not supported yet
      }
      if (obj.type === 2) {  // Enumerate
        Result.type = 'Enumerate'
        Result.name = obj.id
        Result.selected = obj.value
        //console.log(Result.label)
        if(obj.options)
        {
          Result.options = []
          obj.options.forEach(option=>{
            var myoption={}
            myoption.text = option.title
            myoption.value = option.value
            myoption.disabled = option.disabled
            Result.options.push(myoption)
          });
        }
        if (obj.disabled) Result.disabled = obj.disabled
        if (obj.dimension) Result.dim = obj.dimension
      }
      if (obj.type === 3) {  // xml_Boolean
        Result.type = 'Checkbox'
        Result.name = obj.id
        if (obj.disabled) Result.disabled = obj.disabled
      }
      if (obj.type === 4) {  // xml_String
        Result.type = 'Text'
        Result.name = obj.id
        Result.value = obj.value
        if (obj.regex) Result.regex = obj.regex
        if (obj.disabled) Result.disabled = obj.disabled
        if (obj.dimension) Result.dim = obj.dimension
      }
      if (obj.type === 6) {  // xml_Info        
        Result.type = 'Text'
        Result.name = obj.id
        if (obj.dimension) Result.dim = obj.dimension
      }
      if (obj.type === 7) {  // Title
        Result.type = 'Title'
        Result.name = obj.id
      }
      if (obj.type === 100) 
      { // xml_Status
        Result.type = 'Status'
        Result.name = obj.id
        Result.value = obj.value
        Result.inputWidth -= 6
        if (obj.dimension) Result.dim = obj.dimension
      }

      if (obj.disableIf) {
        obj.disableIf.forEach(function (item) {
          if (item.groupId) {
            this.groups.forEach(function (grp, index) {
              if (grp.id && grp.id === item.groupId) {
                if ( RegExp(item.regex).test(this.groups[index].params[item.paramIdx].value) ) {
                  Result.disabled = true
                }
                else 
                  Result.disabled = false
              }
            }, this)
          }
        }, this)
      }

      return Result
    },
    toClick: function (obj) {

      if(this.$refs.form[0].validate())
        this.$store.dispatch("WriteGroupParamsValue",obj)
      else
          this.$store.commit('showMessage', {text: "Invalid parameters", type: 'error'})
    },
    groupsClick: function (obj) {
      if(this.$refs.form[0].validate())
      {
        var _this = this
        obj.groups.forEach(function(grp) {
        _this.$store.dispatch("WriteGroupParamsValue",grp)
        })
      }
      else
          this.$store.commit('showMessage', {text: "Invalid parameters", type: 'error'})

    }
  },
  watch: {

  }

}

</script>


